export default __webpack_public_path__ + "locales/uk-UA/Profile.json?hash=16293df30347236decb8395c09bd0a24";